// start:ng42.barrel
import './feeSummary.component';
// end:ng42.barrel

